import e from "react";
import { VisuallyHidden as t } from "../../../VisuallyHidden/VisuallyHidden.js";
import { X as l } from "@olxbr/ds-icons";
const a = _ref => {
  let {
    closeCallback: o
  } = _ref;
  return e.createElement("button", {
    "data-ds-component": "DS-Modal-Button",
    onClick: o,
    type: "button",
    className: "olx-modal__close-button"
  }, e.createElement(t, null, "Fechar janela de di\xE1logo"), e.createElement(l, null));
};
export { a as Close };